const QyMessage = {
    path: 'qyMessage',
    component: resolve => require(['@/pages/admin/message/qyMessage/list.vue'], resolve)
}

export default QyMessage